import { IApplicationState } from '../../../types/redux';
import { ISpecialist } from '../../../types/specialist';

export const selectAgenciesData = (state: IApplicationState): ISpecialist[] => {
  return state.mainpage.agencies;
};
